var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4167 13.7833H2.75C2.60855 13.7833 2.4729 13.7271 2.37288 13.6271C2.27286 13.5271 2.21667 13.3914 2.21667 13.25V1.58333C2.21667 1.41536 2.14994 1.25427 2.03117 1.1355C1.91239 1.01673 1.7513 0.95 1.58333 0.95C1.41536 0.95 1.25427 1.01673 1.1355 1.1355C1.01673 1.25427 0.95 1.41536 0.95 1.58333V13.25C0.95 13.7274 1.13964 14.1852 1.47721 14.5228C1.81477 14.8604 2.27261 15.05 2.75 15.05H14.4167C14.5846 15.05 14.7457 14.9833 14.8645 14.8645C14.9833 14.7457 15.05 14.5846 15.05 14.4167C15.05 14.2487 14.9833 14.0876 14.8645 13.9688C14.7457 13.8501 14.5846 13.7833 14.4167 13.7833Z",
    fill: "#26445A",
    stroke: "#26445A",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75008 12.7166C9.91805 12.7166 10.0791 12.6499 10.1979 12.5311C10.3167 12.4124 10.3834 12.2513 10.3834 12.0833V7.99996C10.3834 7.83199 10.3167 7.6709 10.1979 7.55213C10.0791 7.43335 9.91805 7.36663 9.75008 7.36663C9.58211 7.36663 9.42102 7.43335 9.30225 7.55213C9.18347 7.6709 9.11675 7.83199 9.11675 7.99996V12.0833C9.11675 12.2513 9.18347 12.4124 9.30225 12.5311C9.42102 12.6499 9.58211 12.7166 9.75008 12.7166Z",
    fill: "#26445A",
    stroke: "#26445A",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08333 12.7166C5.2513 12.7166 5.41239 12.6499 5.53117 12.5311C5.64994 12.4124 5.71667 12.2513 5.71667 12.0833V7.99996C5.71667 7.83199 5.64994 7.6709 5.53117 7.55213C5.41239 7.43335 5.2513 7.36663 5.08333 7.36663C4.91536 7.36663 4.75427 7.43335 4.6355 7.55213C4.51673 7.6709 4.45 7.83199 4.45 7.99996V12.0833C4.45 12.2513 4.51673 12.4124 4.6355 12.5311C4.75427 12.6499 4.91536 12.7166 5.08333 12.7166Z",
    fill: "#26445A",
    stroke: "#26445A",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 12.7167C12.2513 12.7167 12.4124 12.6499 12.5312 12.5312C12.6499 12.4124 12.7167 12.2513 12.7167 12.0833V5.08333C12.7167 4.91536 12.6499 4.75427 12.5312 4.6355C12.4124 4.51673 12.2513 4.45 12.0833 4.45C11.9154 4.45 11.7543 4.51673 11.6355 4.6355C11.5167 4.75427 11.45 4.91536 11.45 5.08333V12.0833C11.45 12.2513 11.5167 12.4124 11.6355 12.5312C11.7543 12.6499 11.9154 12.7167 12.0833 12.7167Z",
    fill: "#26445A",
    stroke: "#26445A",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41659 12.7167C7.58456 12.7167 7.74565 12.6499 7.86442 12.5312C7.98319 12.4124 8.04992 12.2513 8.04992 12.0833V5.08333C8.04992 4.91536 7.98319 4.75427 7.86442 4.6355C7.74565 4.51673 7.58456 4.45 7.41659 4.45C7.24861 4.45 7.08752 4.51673 6.96875 4.6355C6.84998 4.75427 6.78325 4.91536 6.78325 5.08333V12.0833C6.78325 12.2513 6.84998 12.4124 6.96875 12.5312C7.08752 12.6499 7.24861 12.7167 7.41659 12.7167Z",
    fill: "#26445A",
    stroke: "#26445A",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.2ea55635ab00fcb1e888f456b7d5428f.svg";
export { ForwardRef as ReactComponent };